
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SiteModel } from 'models/generated/Distribution.Api.Models.Site';


const _distribution_SiteControllerHelper = new Map<string, Object>();
_distribution_SiteControllerHelper.set('GetSite', SiteModel);
_distribution_SiteControllerHelper.set('GetSitesByProductPlanIds', SiteModel);
_distribution_SiteControllerHelper.set('AddSite', SiteModel);


export const distribution_SiteControllerHelper = _distribution_SiteControllerHelper;

